export default function($rootScope, $timeout, $compile) {
  "ngInject";
  return function(scope, element, attrs) {

    scope.$watch(function(scope) {
      return scope.$parent.vm.contentArray;
    }, (newVal, oldVal) => {
      $timeout(() => {
        var html = angular.element(element[0]).html();
        // Datatable
        angular.element(element[0]).html(html.replace('[companies filter="eventDataKsu"]', '<datatable data-filter="\'eventDataKsu\'"></datatable>')
          .replace('[companies filter="eventDataAsset"]', '<datatable data-filter="\'eventDataAsset\'"></datatable>')
          .replace('[companies filter="eventDataStock"]', '<datatable data-filter="\'eventDataStock\'"></datatable>')
          .replace('[companies]', '<datatable data-filter="\'\'"></datatable>')
          .replace('[programm day="0"]', '<scheduler day="\'0\'"></scheduler>')
          .replace('[programm day="1"]', '<scheduler day="\'1\'"></scheduler>')
          .replace('[programm day="2"]', '<scheduler day="\'2\'"></scheduler>'));
        $compile(element.contents())(scope);
      });
    });

  }
}



// WEBPACK FOOTER //
// ./client/app/common/directives/parse.directive.js